var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('day-agenda-list-item-placeholder'),_c('day-agenda-list-item-placeholder'),_c('day-agenda-list-item-placeholder')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }